/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

// This code is auto-generated by Plasmic; please do not edit!
// Plasmic Project: iDYgiKJB9Yi7CUB81stQBK

import * as React from "react";

import { _useGlobalVariants } from "./plasmic"; // plasmic-import: iDYgiKJB9Yi7CUB81stQBK/projectModule
import { AuthGlobalContext } from "@/common/fragment/authGlobalContext"; // plasmic-import: M65oXRA032VP/codeComponent
import { Fragment } from "@/common/fragment/designSystemGlobalContext"; // plasmic-import: uqFwzM_jGhaf/codeComponent
import { GrowthbookGlobalContext } from "@/common/fragment/growthbookGlobalContext"; // plasmic-import: PExaD6WE-TOc/codeComponent
import { Splunk } from "@/common/fragment/splunk"; // plasmic-import: 4nkGdrqDgqHB/codeComponent
import { PWA } from "@/common/fragment/pwa"; // plasmic-import: C45nyjhdGN4U/codeComponent
import { HamdastAppsSelectorModalProvider } from "@/modules/hamdast/components/apps-selector-modal"; // plasmic-import: r6d65fDzyF5h/codeComponent
import { EmbedCss } from "@plasmicpkgs/plasmic-embed-css";

export interface GlobalContextsProviderProps {
  children?: React.ReactElement;
  authGlobalContextProps?: Partial<
    Omit<React.ComponentProps<typeof AuthGlobalContext>, "children">
  >;

  fragmentProps?: Partial<
    Omit<React.ComponentProps<typeof Fragment>, "children">
  >;

  growthbookGlobalContextProps?: Partial<
    Omit<React.ComponentProps<typeof GrowthbookGlobalContext>, "children">
  >;

  splunkProps?: Partial<Omit<React.ComponentProps<typeof Splunk>, "children">>;
  pwaProps?: Partial<Omit<React.ComponentProps<typeof PWA>, "children">>;
  hamdastAppsSelectorModalProviderProps?: Partial<
    Omit<
      React.ComponentProps<typeof HamdastAppsSelectorModalProvider>,
      "children"
    >
  >;

  embedCssProps?: Partial<
    Omit<React.ComponentProps<typeof EmbedCss>, "children">
  >;
}

export default function GlobalContextsProvider(
  props: GlobalContextsProviderProps
) {
  const {
    children,
    authGlobalContextProps,
    fragmentProps,
    growthbookGlobalContextProps,
    splunkProps,
    pwaProps,
    hamdastAppsSelectorModalProviderProps,
    embedCssProps
  } = props;

  return (
    <AuthGlobalContext
      {...authGlobalContextProps}
      previewToken={
        authGlobalContextProps && "previewToken" in authGlobalContextProps
          ? authGlobalContextProps.previewToken!
          : undefined
      }
    >
      <Fragment
        {...fragmentProps}
        apiConfig={
          fragmentProps && "apiConfig" in fragmentProps
            ? fragmentProps.apiConfig!
            : undefined
        }
        previewApiConfig={
          fragmentProps && "previewApiConfig" in fragmentProps
            ? fragmentProps.previewApiConfig!
            : undefined
        }
      >
        <GrowthbookGlobalContext
          {...growthbookGlobalContextProps}
          apiHost={
            growthbookGlobalContextProps &&
            "apiHost" in growthbookGlobalContextProps
              ? growthbookGlobalContextProps.apiHost!
              : "https://growthbook-api.paziresh24.com"
          }
          clientKey={
            growthbookGlobalContextProps &&
            "clientKey" in growthbookGlobalContextProps
              ? growthbookGlobalContextProps.clientKey!
              : "sdk-St1dBftdp07geqtD"
          }
          previewAttributes={
            growthbookGlobalContextProps &&
            "previewAttributes" in growthbookGlobalContextProps
              ? growthbookGlobalContextProps.previewAttributes!
              : undefined
          }
        >
          <Splunk
            {...splunkProps}
            defaultApiHost={
              splunkProps && "defaultApiHost" in splunkProps
                ? splunkProps.defaultApiHost!
                : "https://p24-shelter-splunk-hec.paziresh24.com"
            }
            defaultApiKey={
              splunkProps && "defaultApiKey" in splunkProps
                ? splunkProps.defaultApiKey!
                : "49a5600c-e81d-4b55-8e32-c668f0faf4f0"
            }
          >
            <PWA {...pwaProps}>
              <HamdastAppsSelectorModalProvider
                {...hamdastAppsSelectorModalProviderProps}
                onAppSelect={
                  hamdastAppsSelectorModalProviderProps &&
                  "onAppSelect" in hamdastAppsSelectorModalProviderProps
                    ? hamdastAppsSelectorModalProviderProps.onAppSelect!
                    : undefined
                }
              >
                <EmbedCss
                  {...embedCssProps}
                  css={
                    embedCssProps && "css" in embedCssProps
                      ? embedCssProps.css!
                      : ".pl__z-50{\r\n  z-index: 9999 !important;\r\n}"
                  }
                >
                  {children}
                </EmbedCss>
              </HamdastAppsSelectorModalProvider>
            </PWA>
          </Splunk>
        </GrowthbookGlobalContext>
      </Fragment>
    </AuthGlobalContext>
  );
}
